import { useEffect, useState } from "react";
import { api } from "./api";
import { stripHtml } from "./i18n";

const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const inline = (s) => esc(s).replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/(^|\W)\*(.+?)\*(?=\W|$)/g, "$1<em>$2</em>");

export function mdToHtml(md = "") {
  const out = [];
  let list = null;
  const close = () => { if (list) { out.push(`</${list}>`); list = null; } };
  for (const raw of String(md).split(/\r?\n/)) {
    const line = raw.trim();
    const h = line.match(/^(#{1,4})\s+(.*)$/);
    const li = line.match(/^[-*•]\s+(.*)$/) || line.match(/^\d+[.)]\s+(.*)$/);
    if (!line) { close(); continue; }
    if (h) { close(); const lv = Math.min(4, h[1].length + 1); out.push(`<h${lv}>${inline(h[2])}</h${lv}>`); continue; }
    if (li) {
      const num = line.match(/^(\d+)[.)]/);
      const tag = num ? "ol" : "ul";
      if (list !== tag) { close(); out.push(num ? `<ol start="${num[1]}">` : "<ul>"); list = tag; }
      out.push(`<li>${inline(li[1])}</li>`);
      continue;
    }
    close();
    out.push(`<p>${inline(line)}</p>`);
  }
  close();
  return out.join("");
}

export const fmtCount = (n, lang) => new Intl.NumberFormat(lang === "tr" ? "tr-TR" : "en-US", { notation: "compact", maximumFractionDigits: 1 }).format(n || 0);

const STOP = new Set((
  "ve veya ile için gibi daha çok bir bu şu olan olarak kadar sonra önce üzere her hangi " +
  "nasıl neden ama fakat ancak yani hem ise değil çünkü böyle şöyle diye tüm bütün arada " +
  "karşı göre dolayı rağmen beri doğru sadece yine ben sen biz siz onlar " +
  "the and for with that this from are was were has have will your you our their about into " +
  "they them then than when what which while would could should http https www com"
).split(" "));

export function autoTags(title, body, extra, n = 6) {
  const pick = (o) => (o && typeof o === "object" ? o.tr || o.en || "" : o || "");
  const text = `${pick(title)} ${pick(extra)} ${stripHtml(pick(body))}`.toLowerCase();
  const freq = {};
  for (const w of text.match(/[a-zçğıöşü0-9]{4,}/g) || []) {
    if (STOP.has(w)) continue;
    freq[w] = (freq[w] || 0) + 1;
  }
  return Object.keys(freq).sort((a, b) => freq[b] - freq[a] || a.localeCompare(b)).slice(0, n);
}

export function useViewCount(kind, slug, initial) {
  const [views, setViews] = useState(initial);
  useEffect(() => {
    if (!slug) return;
    setViews(initial);
    const key = `viewed:${kind}:${slug}`;
    const last = Number(localStorage.getItem(key) || 0);
    if (Date.now() - last < 12 * 3600 * 1000) return;
    localStorage.setItem(key, String(Date.now()));
    const url = kind === "news" ? `/public/news/${slug}/view` : `/public/videos/${slug}/view`;
    api.post(url).then((r) => setViews(r.data.views)).catch(() => {});
  }, [kind, slug]); // eslint-disable-line react-hooks/exhaustive-deps
  return views;
}
